import { render, staticRenderFns } from "./AddSubcategory.vue?vue&type=template&id=3456eff0"
import script from "./AddSubcategory.vue?vue&type=script&lang=js"
export * from "./AddSubcategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports